import { gql } from '@apollo/client';

export default gql`
  mutation deleteInspection($id: ID!) {
    deleteInspection(input: { id: $id }) {
      success
    }
  }
`;
